export const MAX_EXTRA_DAYS = 7;
export const EXPIRED_GRACE_DAYS = 3;

/** Classify the promo that can still be acted on for a plan.
 *  Returns { promo, isActive, isRecentlyExpired, daysSinceExpiry } or null. */
export const getExtendablePromo = (plan) => {
  const now = Date.now();
  for (const p of [...(plan?.promotions || [])].reverse()) {
    if (!["active", "expired"].includes(p.status)) continue;
    const until = new Date(p.valid_until).getTime();
    if (Number.isNaN(until)) continue;
    if (until > now) return { promo: p, isActive: true, isRecentlyExpired: false, daysSinceExpiry: 0 };
    const days = (now - until) / 86400000;
    if (days <= EXPIRED_GRACE_DAYS) return { promo: p, isActive: false, isRecentlyExpired: true, daysSinceExpiry: days };
  }
  return null;
};

export const graceDeadline = (promo) => new Date(new Date(promo.valid_until).getTime() + EXPIRED_GRACE_DAYS * 86400000);
